import type { RouteRecordRaw } from 'vue-router'

export type NavigationItem = {
  title: string
  path: string
  icon: string
  resource?: string
  permission?: string
}

export type NavigationGroup = { title: string; items: NavigationItem[] }

export const navigationGroups: NavigationGroup[] = [
  { title: '', items: [{ title: '工作台', path: '/', icon: 'home' }] },
  { title: '订单与配送', items: [
    { title: '订单管理', path: '/orders', icon: 'orders', resource: 'orders' },
    { title: '配送调度', path: '/dispatch', icon: 'dispatch', resource: 'deliveries' },
    { title: '异常订单', path: '/exceptions', icon: 'warning', resource: 'exceptions' },
    { title: '退款售后', path: '/refunds', icon: 'refund', resource: 'refunds' },
  ] },
  { title: '商家与商品', items: [
    { title: '商家管理', path: '/merchants', icon: 'merchant', resource: 'merchants' },
    { title: '入驻审核', path: '/merchant-applications', icon: 'approved', resource: 'merchant-applications' },
    { title: '商品管理', path: '/products', icon: 'product', resource: 'products' },
    { title: '分类管理', path: '/categories', icon: 'category', resource: 'categories' },
  ] },
  { title: '用户运营', items: [
    { title: '用户管理', path: '/customers', icon: 'user', resource: 'customers' },
    { title: '会员中心', path: '/members', icon: 'member', resource: 'membership-tiers' },
    { title: '骑手管理', path: '/riders', icon: 'rider', resource: 'riders' },
    { title: '骑手审核', path: '/rider-applications', icon: 'approved', resource: 'rider-applications' },
  ] },
  { title: '营销与内容', items: [
    { title: '优惠券', path: '/coupons', icon: 'coupon', resource: 'coupons' },
    { title: '营销活动', path: '/campaigns', icon: 'campaign', resource: 'campaigns' },
    { title: '内容管理', path: '/contents', icon: 'content', resource: 'contents' },
    { title: '投诉工单', path: '/complaints', icon: 'complaint', resource: 'complaints' },
    { title: '消息中心', path: '/notifications', icon: 'notification', resource: 'notifications' },
  ] },
  { title: '系统治理', items: [
    { title: '管理员', path: '/administrators', icon: 'admin', resource: 'system/administrators', permission: 'system:administrators:read' },
    { title: '角色与权限', path: '/roles', icon: 'role', resource: 'system/roles', permission: 'system:roles:read' },
    { title: '审计日志', path: '/audit', icon: 'audit', resource: 'system/audit-logs', permission: 'system:audit:read' },
    { title: '后台任务', path: '/jobs', icon: 'job', resource: 'jobs' },
    { title: '系统告警', path: '/alerts', icon: 'alert', resource: 'alerts' },
  ] },
]

export const businessNavigation = navigationGroups.flatMap(group => group.items).filter(item => item.resource)

export const hasPermission = (permission: unknown, user: Record<string, any>) => {
  if (!permission) return true
  if (user.roles?.includes('super_admin')) return true
  return Array.isArray(user.permissions) && user.permissions.includes(permission)
}

export const businessRoutes = (): RouteRecordRaw[] => businessNavigation.map(item => ({
  path: item.path,
  component: () => import('../views/BusinessListView.vue'),
  meta: { title: item.title, resource: item.resource, permission: item.permission },
}))
